import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import RowContainer from '../../shared/CheckoutRowContainer';
import ApplePayIcon from 'dibs-icons/exports/legacy/ApplePay';
import styles from './styles/CheckoutApplePay.scss';

const CheckoutApplePay = props => {
    const { wrapperClass } = props;

    return (
        <div
            className={classnames(wrapperClass, styles.wrapper)}
            data-tn="checkout-apple-pay-web-wrapper"
        >
            <RowContainer noMargin isClickable={false} wrapperClass={styles.rowContainerWrapper}>
                <div className={styles.applePayIconContainer}>
                    <ApplePayIcon className={styles.applePayIcon} />
                </div>
                <p className={styles.information} data-tn="billing-form-help-text">
                    <FormattedMessage
                        id="checkout.CheckoutApplePay.description1"
                        defaultMessage="Make your payment easily and securely using your iPhone, iPad or computer with Face ID or Touch ID."
                    />
                </p>
                <br />
                <p className={styles.information} data-tn="billing-form-help-text">
                    <FormattedMessage
                        id="checkout.CheckoutApplePay.description2"
                        defaultMessage="Select Continue below to authorize payment using cards stored in your Apple Wallet. If you have no payment methods stored, you will be prompted to add one. Please note: Apple Pay may use recognition technology such as Touch ID to verify your identity."
                    />
                </p>
                <br />
            </RowContainer>
        </div>
    );
};

CheckoutApplePay.propTypes = {
    wrapperClass: PropTypes.string.isRequired,
};

export default CheckoutApplePay;
